import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { withResourceEarlyData } from './withResourceEarlyData.tsx';
import getData from './getData.tsx';

/**
 * @deprecated DO NOT USE ANYMORE
 * See here for details: https://hello.atlassian.net/wiki/spaces/JFP/pages/6034403445/Investigate+Optimise+issueViewInteractiveQuery
 */
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const issueGiraDataResource: RouteResource<any> = createResource<any>(
	withResourceEarlyData({
		type: 'ISSUE_GIRA_DATA',
		getKey: (routerContext) => {
			let issueKey = getIssueKey(routerContext.match);

			if (
				!issueKey &&
				(fg('nin_glance_panel_technical_changes') || fg('nin_issue_app_conditional_entrypoint'))
			) {
				issueKey = routerContext.query?.selectedIssue ?? '';
			}

			return issueKey || '';
		},
		getData: (...args) => getData(...args),
	}),
);
